/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { QuerySuggestionViewModel } from '../viewModels/QuerySuggestionViewModel';
import { activeSectionItem, focusBorder, maginifierIcon, pastQueryItemIcon, querySuggestionItem, querySuggestionItemIcon, querySuggestionSection, section, sectionHeader, sectionHeaderTitle, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout, useColorForHighlight } from './OmniboxV2Styles';

export const QuerySuggestionTestId = 'QuerySuggestion';

export function QuerySuggestion(props: { viewModel: QuerySuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    viewModel.showClearConfirmationDialog = () => {
        const dialog = openReactConfirmationDialog<void, void>({
            title: Messages.omniboxClearPastQueryConfirmationDialogTitle(),
            message: Messages.omniboxClearPastQueryConfirmationDialogMessage(),
            paramsForAction: undefined,
            actionName: Messages.omniboxClearPastQueryConfirmationDialogActionName(),
            action: (params) => {
                viewModel.removeAllpastQueryItem();
                return Promise.resolve();
            },
            isActionDelete: true,
            dialogWidth: TabDialogWidth.width375px
        });

        dialog.result.catch(() => {
            viewModel.onClearConformationDialogDismissed();
        });
    };

    return (viewModel.querySuggestionItems && viewModel.querySuggestionItems.length > 0) ? <div data-tb-test-id={QuerySuggestionTestId} className={[section, querySuggestionSection, (viewModel.omniboxViewModel.shouldUseColorHighlight() ? useColorForHighlight : null)].join(' ')}>
        {viewModel.shouldShowHeader ? <div className={sectionHeader}>
            <div className={[sectionItemAutoFitContent, sectionHeaderTitle].join(' ')}>{Messages.omniboxClearPastQueryHeader()}</div>
            <div className={sectionItemFixedContent} style={{ paddingRight: 2 }}>
                <a id={viewModel.clearButtonNavigationItem.getIdentifier()} href='#' role='option' aria-selected={viewModel.clearButtonNavigationItem === viewModel.currentKeyboardNavigableItem}
                    className={viewModel.clearButtonNavigationItem === viewModel.currentKeyboardNavigableItem ? focusBorder : null} onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onClearClicked(); }}>
                    {Messages.omniboxClearPastQueryClear()}
                </a>
            </div>
        </div> : null}
        {
            viewModel.querySuggestionItems.map((item, index) => <a id={item.getIdentifier()} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem} key={index} href={item.url} className={[sectionItem, sectionItemHorizontalLayout, querySuggestionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')} onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.hitPastQueryItem(item, index); }}>
                <div className={[sectionItemFixedContent, querySuggestionItemIcon, item.isPastQuery ? pastQueryItemIcon : maginifierIcon].join(' ')}></div>
                <div className={sectionItemAutoFitContent} style={CommonStyles.Layout.TextEllipsis}>
                    {item.segments.map((segment, index) => <span key={index}>{segment.keywordToAppend ? <strong>{segment.text}</strong> : <>{segment.text}</>}</span>)}
                </div>
            </a>)
        }
    </div > : null;
}